import React from "react";
import { component_tool } from '../../../../tool'
import moment from "moment";
import {WizTableForm} from "../../../common";
let { WizDataTable, WizButton } = component_tool
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 } })
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1 } })

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}
const _getValue = (type, key) => {
  const values = {
    pass: {
      0: '未通过',
      1: '通过',
      2: '批阅中'
    },faceStatus: {
      0: '无需身份验证审核',
      1: '身份验证审核通过',
      2: '身份验证待审核',
      3: '身份验证未通过'
    },
  }
  return values[type][key]
}
export default (self) => {
  return [
    {
      title: 'examId',
      name: 'examId',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: 'id',
      name: 'id',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: '姓名',
      name: 'fullName',
      tableItem: {},
      searchItem: {}
    },
    {
      title: '账号',
      name: 'userName',
      tableItem: {},
      searchItem: {}
    },
    {
      title: '组织',
      name: 'orgId',
      searchItem: {
        ...organizationConfig,
        diy: WizTableForm,
        selectType: 'radio',
      },
    },
    {
      title: '岗位',
      name: 'posId',
      searchItem: {
        ...positionConfig,
        diy: WizTableForm,
        selectType: 'radio',
      },
    },
    {
      title: '状态',
      name: 'pass',
      searchItem: {
        type: 'select'
      },
      dict: [
        { code: 0, codeName: '未通过' },
        { code: 1, codeName: '通过' },
        { code: 2, codeName: '批阅中' },
        // { code: 3, codeName: '身份验证待审核' },
        // { code: 4, codeName: '身份验证未通过' },
      ],
    },
    {
      title: '手机号',
      name: 'mobile',
      tableItem: {}
    },
    // {
    //   title: '证件号码',
    //   name: 'idCard',
    //   tableItem: {}
    // },
    {
      title: '成绩',
      name: 'score',
      tableItem: {
        render(text,record) {
          if (record.pass == 2) {
            return null
          } else {
            return text
          }
        }
      }
    },
    {
      title: '状态',
      name: 'pass',
      tableItem: {
        render(text,record) {
          const {pass,faceStatus} = record;
          let passName= _getValue('pass', pass);
          if (faceStatus ===null || faceStatus===undefined || (faceStatus===0 || faceStatus===1)){
            passName = _getValue('pass', pass);
          }else {
            passName = _getValue('faceStatus', faceStatus)
          }
          return passName;
        }
      },
      dict: [
        { code: 0, codeName: '未通过' },
        { code: 1, codeName: '通过' },
        { code: 2, codeName: '批阅中' },
      ],
    },
    {
      title: '组织名称',
      name: 'orgName',
      tableItem: {},
    },
    {
      title: '组织编码',
      name: 'orgCode',
      tableItem: {}
    },
    {
      title: '岗位',
      name: 'positionName',
      tableItem: {}
    },
    {
      title: '任职状态',
      name: 'jobState',
      tableItem: {},
      dict: [
        { code: 0, codeName: '离职' },
        { code: 1, codeName: '在职' },
      ],
    },
    {
      title: '用户属性',
      name: 'userType',
      dataIndex: 'userType',
      tableItem: {},
      dict: [
        { code: 0, codeName: "培训平台用户" },
        { code: 5, codeName: "服务商用户" },
        { code: 4, codeName: "经销商用户" },
        { code: 3, codeName: "OEM部门用户" }
      ]
    },
    {
      title: "账号状态",
      name: "disabled",
      dataIndex: "disabled",
      tableItem: {},
      dict: [
        { code: 0, codeName: "激活" },
        { code: 1, codeName: "禁用" }
      ]
    },
    {
      title: '考试开始时间',
      name: 'startDate',
      tableItem: {
        render: (text => {
          return formatterDate(text)
        })
      }
    },
    {
      title: '考试结束时间',
      name: 'endDate',
      tableItem: {
        render: (text => {
          return formatterDate(text)
        })
      }
    },
    {
      title: '操作',
      tableItem: {
        fixed: 'right',
        render: (text, record) => (
          <WizDataTable.Oper>
            <WizButton tooltip="查看任职" onClick={e => self._onLookPosition(record,e)}>
              查看任职
            </WizButton>
          </WizDataTable.Oper>
        )
      }
    }
  ]
}
